export default "__VITE_ASSET__edad77ba__"